import { Mapping } from 'api/MappingsAPI';
import { fieldTypeToComparators } from '../../../../constants';
import { DynamicFieldType } from '../../../../domain';

/** util to get handlebar comparators based an event or profile's field name */
export const getHandlebarComparatorsFromFieldName = (selectedFieldName = '', fields: Mapping[]) => {
  const chosenField = fields.find(({ fieldName }) => fieldName === selectedFieldName);
  const handlebarComparators = fieldTypeToComparators[chosenField?.fieldType as DynamicFieldType];
  const comparators = chosenField ? handlebarComparators : [];
  return comparators;
};
